import { toAbsoluteUrl } from '@/_metronic/helpers'
import clsx from 'clsx'
import { FC, useMemo, useState } from 'react'
import SVG from 'react-inlinesvg'
import { useLocation } from 'react-router-dom'
import { useBookOrder } from '../../book-order/core/BookOrderProvider'
import IntakeForm from './IntakeForm'
import SurveyForm from './SurveyForm'

type Props = {
  outlet_id: string
  handleSubmit: (value: any) => void | Promise<void>
}
const SurveyCustomerForm: FC<Props> = ({outlet_id, handleSubmit}) => {
  const location = useLocation()

  const [formType, setFormType] = useState('intake')
  const {outlet} = useBookOrder()

  const handleIntakeSuccess = () => {
    setFormType('survey')
  }

  const isSurveyCustomer = useMemo(() => {
    return location.pathname?.startsWith('/survey-customer')
  }, [location])

  return (
    <>
      <div className='row mt-2'>
        <div className='col-12 mb-8'>
          <h2>{outlet?.outlet_name}</h2>
        </div>
        <div className='col-lg-6'>
          <div
            className='position-relative overflow-hidden cursor-pointer'
            onClick={() => Boolean(outlet_id) && setFormType('intake')}
          >
            <label
              className={clsx(
                'btn btn-outline btn-outline btn-outline-default p-4 d-flex align-items-center justify-content-center mb-10',
                {
                  'border-info text-info': formType === 'intake',
                  bi: formType !== 'intake',
                }
              )}
              htmlFor='kt_create_account_form_account_type_personal'
            >
              <SVG
                className='fs-3x me-3'
                src={toAbsoluteUrl(
                  formType === 'intake'
                    ? '/media/svg/orders/ri_hotel_enable.svg'
                    : '/media/svg/orders/ri_hotel_disable.svg'
                )}
              />

              <span className='d-block fw-bold text-start'>
                <span className='d-block fs-4'>Intake</span>
              </span>
            </label>
          </div>
        </div>

        <div className='col-lg-6'>
          <div
            className='position-relative overflow-hidden cursor-pointer'
            onClick={() => Boolean(outlet_id) && setFormType('survey')}
          >
            <label
              className={clsx(
                'btn btn-outline btn-outline btn-outline-default p-4 d-flex align-items-center justify-content-center mb-10',
                {
                  'border-info text-info': formType === 'survey',
                  bi: formType !== 'survey',
                }
              )}
              htmlFor='kt_create_account_form_account_type_personal'
            >
              <SVG
                className='fs-3x me-3'
                src={toAbsoluteUrl(
                  formType === 'survey'
                    ? '/media/svg/orders/unlock_enable.svg'
                    : '/media/svg/orders/unlock_disable.svg'
                )}
              />

              <span className='d-block fw-bold text-start'>
                <span className='d-block fs-4'>Survey</span>
              </span>
            </label>
          </div>
        </div>
      </div>

      {isSurveyCustomer && <div className='h-15px' />}

      {formType === 'intake' && (
        <IntakeForm
          key='intake'
          outlet_id={outlet_id}
          handleSubmit={handleSubmit}
          onSuccess={handleIntakeSuccess}
        />
      )}
      {formType === 'survey' && (
        <SurveyForm key='survey' outlet_id={outlet_id} handleSubmit={handleSubmit} />
      )}
    </>
  )
}

export default SurveyCustomerForm
